import React from 'react';
import { Route } from 'react-router';

export default (
  <Route
    path="consult"
    onEnter={(_, __, cb) => {
      try {
        window.HubSpotConversations.widget.refresh();
      } catch (err) {
        // Swallowing errors but want to use try catch finally bc an error in here
        //  will freeze the page
      } finally {
        cb();
      }
    }}
  />
);



// WEBPACK FOOTER //
// ./src/products/consult.js